import { _formatDate } from "../../../libs/dateUtils";
import { get, post, del, urlApiTegra } from "../../../service/api";
import { TimeSheetProps } from "../model";

function getPointsByDay(token: string, userId: number, date: string) {
  const queryString = `?userId=${userId}&date=${date}`;
  return get(`${urlApiTegra}/time-points${queryString}`, token);
}

async function savePoints(data: TimeSheetProps, token: string) {
  return await post(`${urlApiTegra}/time-points`, data, token);
}

function getClientsUserId(token: string) {
  return get(`${urlApiTegra}/search-client`, token);
}

function getProjectsByClient(token: string, clientId: number) {
  return get(`${urlApiTegra}/search-project/${clientId}`, token);
}

function getPointsByDayRange(token: string, userId: number, dataFrom: string, dataTo: string) {
  const queryString = `?userId=${userId}&dateFrom=${_formatDate(dataFrom)}&dateTo=${_formatDate(dataTo)}`;
  return get(`${urlApiTegra}/time-points/range${queryString}`, token);
}

function deletePointsByDate(data: string, token: string) {
  const queryString = `?date=${data}`;
  return del(`${urlApiTegra}/time-points/${queryString}`, token);
}

export { getPointsByDay, savePoints, getClientsUserId, getProjectsByClient, getPointsByDayRange, deletePointsByDate };
